import { render, staticRenderFns } from "./sub-form-item.vue?vue&type=template&id=0f27745c&scoped=true&"
import script from "./sub-form-item.vue?vue&type=script&lang=js&"
export * from "./sub-form-item.vue?vue&type=script&lang=js&"
import style0 from "./sub-form-item.vue?vue&type=style&index=0&id=0f27745c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27745c",
  null
  
)

export default component.exports